function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesCac19Cinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.204 87.792 381.417 3.125c-4.173-4.167-10.932-4.167-15.105 0a10.65 10.65 0 0 0 0 15.083L379.122 31l-70.35 70.25-44.855-44.792c-4.173-4.167-10.932-4.167-15.105 0a10.65 10.65 0 0 0 0 15.083L273.305 96 67.22 301.792a10.65 10.65 0 0 0-3.129 7.542c0 22.622 8.202 43.164 21.358 59.589l-82.32 82.203a10.65 10.65 0 0 0 0 15.083 10.66 10.66 0 0 0 7.552 3.125c2.733 0 5.466-1.042 7.552-3.125l82.32-82.203c16.448 13.138 37.019 21.328 59.673 21.328a10.68 10.68 0 0 0 7.552-3.125l206.084-205.792 24.493 24.458a10.66 10.66 0 0 0 7.552 3.125c2.733 0 5.466-1.042 7.552-3.125a10.65 10.65 0 0 0 0-15.083l-46.524-46.458 70.35-70.25 13.811 13.792a10.66 10.66 0 0 0 7.552 3.125c2.733 0 5.466-1.042 7.552-3.125a10.65 10.65 0 0 0 .004-15.084M155.708 383.875c-37.76-2.146-68.104-32.49-70.25-70.25L96 303.083l24.458 24.458a10.63 10.63 0 0 0 7.542 3.125c2.729 0 5.458-1.042 7.542-3.125 4.167-4.167 4.167-10.917 0-15.083L111.083 288l27.583-27.583 13.792 13.792a10.63 10.63 0 0 0 7.542 3.125c2.729 0 5.458-1.042 7.542-3.125 4.167-4.167 4.167-10.917 0-15.083l-13.792-13.792 27.583-27.583 24.458 24.458a10.63 10.63 0 0 0 7.542 3.125c2.729 0 5.458-1.042 7.542-3.125 4.167-4.167 4.167-10.917 0-15.083l-24.458-24.458L224 175.083l13.792 13.792a10.63 10.63 0 0 0 7.542 3.125c2.729 0 5.458-1.042 7.542-3.125 4.167-4.167 4.167-10.917 0-15.083L239.083 160 288 111.083l70.25 70.25zM351.333 144.25l-27.917-27.917 70.25-70.25L421.583 74Z",
    style: {
      fill: "#263238",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "scale(.12784)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesCac19Cinza);
export default __webpack_public_path__ + "static/media/Icones_cac_19_cinza.92945cc3978448b4d7d14129fc8fddb7.svg";
export { ForwardRef as ReactComponent };